import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import './DropdownControl.css';
import { useNavigate } from "react-router-dom";
import { useMapEvents } from 'react-leaflet';

let basemapsarctic = {
  Esri_Ocean: L.tileLayer(
    'https://services.arcgisonline.com/ArcGIS/rest/services/Polar/Arctic_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
    { attribution: '&copy; ESRI & contributors' }
  ),

  Esri_Satellite: L.tileLayer('https://services.arcgisonline.com/arcgis/rest/services/Polar/Arctic_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: '&copy; OpenStreetMap contributors'
  }),
    
};

let basemaps = {
    
  OpenStreetMap: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }),
  Esri_Satellite: L.tileLayer(
    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    { attribution: '&copy; ESRI & contributors' }
  ),
};

const DropdownControl = ({layer1}) => {
    
  const map = useMap();
  const navigate = useNavigate();
  const [coordEl, setCoordEl] = useState(null);
  const [selectedLayer1, setSelectedLayer1] = useState(localStorage.getItem('crs'));
  const urlParams = new URLSearchParams(window.location.search);
  let id = urlParams.get('id');
  if(!id) {
      id = '11311271'
  }


  useMapEvents({
    mousemove(e) {
      if (coordEl) {
        coordEl.innerText = `${e.latlng.lng.toFixed(5)}, ${e.latlng.lat.toFixed(5)}`;
      }
    },
    mouseout() {
      if (coordEl) {
        coordEl.innerText = '--';
      }
    }
  });


  useEffect(() => {
   
const selectedBasemaps = layer1.toLowerCase() === "ok" ? basemapsarctic : basemaps;
if (layer1.toLowerCase() === "ok") {
  // Remove all basemaps from basemapsarctic before adding the new one
  Object.values(basemapsarctic).forEach((layer) => map.removeLayer(layer));
  Object.values(basemaps).forEach((layer) => map.removeLayer(layer));
  basemapsarctic.Esri_Ocean.addTo(map);
}

if (layer1.toLowerCase() === "002") {
  // Remove all basemaps from basemaps before adding the new one
  Object.values(basemapsarctic).forEach((layer) => map.removeLayer(layer));
  Object.values(basemaps).forEach((layer) => map.removeLayer(layer));
  basemaps.OpenStreetMap.addTo(map);
}

    

    const control = L.control({ position: 'topright' });

    control.onAdd = () => {
      const div = L.DomUtil.create('div', 'leaflet-control custom-layer-panel shadow-xl');

      div.innerHTML = `
        <div class="relative ">
        <div class="flex">
        <div >
        <div id="coord-box" class="absolute top-5 right-16 whitespace-nowrap overflow-hidden text-ellipsis backdrop-blur-sm bg-[#0156b3]/70 shadow-md rounded-xl py-1 px-2 transition-transform duration-200 border border-white/30 text-white text-sm text-right">
  --
</div>

        </div>
        <div>
          <button id="collapseToggle" class="absolute top-4 right-4 backdrop-blur-sm bg-[#0156b3]/70 shadow-md rounded-xl p-2 transition-transform duration-200 border border-white/30">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h10M7 16h10M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
               </svg>
</button>
</div>
</div>
          <div class="h-[60px]"></div>
          <div class="panel-section w-96 bg-white text-gray-800 rounded-lg p-4 font-sans text-sm space-y-4 hidden">

            <div class="section">
              <div class="flex items-center justify-between section-header cursor-pointer border-b pb-2 font-semibold text-base">
                <span>Basemap Layers</span>
                <span class="toggle-icon text-gray-500">▶</span>
              </div>
              <div class="section-content mt-2 space-y-2 hidden">
                ${Object.keys(selectedBasemaps)
                  .map(
                    (name) => `
                  <label class="flex items-center gap-2">
                    <input type="radio" name="basemap" value="${name}" class="radio" ${
                      name === 'Esri_Ocean' || name === 'OpenStreetMap' ? 'checked' : ''
                    }>
                    <span>${name.replace('_', ' ')}</span>
                  </label>`
                  )
                  .join('')}
              </div>
            </div>

            <div class="section">
              <div class="flex items-center justify-between section-header cursor-pointer border-b pb-2 font-semibold text-base">
                <span>Projections</span>
                <span class="toggle-icon text-gray-500">▶</span>
              </div>
              <div class="section-content mt-2 max-h-40 overflow-y-auto space-y-2 hidden">
                ${generateView([
                  'Arctic',
                  'Geographical',
                ],selectedLayer1)}
              </div>
            </div>

            <div class="section">
              <div class="flex items-center justify-between section-header cursor-pointer border-b pb-2 font-semibold text-base">
                <span>Datasets</span>
                <span class="toggle-icon text-gray-500">▶</span>
              </div>
              <div class="section-content mt-2 max-h-40 overflow-y-auto space-y-2 hidden">
                ${generateProducts([
                  'Inventory of Subglacial Water',
                  'Elevation Change Rate of Glaciers',
                  'Circumpolar Arctic Vegetation',
                    'Temperature and Pressure Wells in Kaffiøyra',
                    'Shorelines and glacier outlines in Kaffiøyra',
                ], id)}
              </div>
            </div>

          </div>
        </div>
      `;

      L.DomEvent.disableScrollPropagation(div);
      L.DomEvent.disableClickPropagation(div);

      // Toggle sections visibility
      const headers = div.querySelectorAll('.section-header');
      headers.forEach((header) => {
        header.addEventListener('click', () => {
          const content = header.nextElementSibling;
          const icon = header.querySelector('.toggle-icon');
          content.classList.toggle('hidden');
          icon.textContent = content.classList.contains('hidden') ? '▶' : '▼';
        });
      });

      // Toggle entire panel visibility
        const toggleBtn = div.querySelector('#collapseToggle');
        let collapsed = true;
        
        toggleBtn.addEventListener('click', () => {
          collapsed = !collapsed;
          const panel = div.querySelector('.panel-section');
          panel.classList.toggle('hidden', collapsed);
          const contents = div.querySelectorAll('.section-content');
          const icons = div.querySelectorAll('.toggle-icon');

contents.forEach((content, i) => {
    if (collapsed) {
      content.classList.remove('hidden');
      icons[i].textContent = '▼';
    } else {
      content.classList.add('hidden');
      icons[i].textContent = '▶';
    }
  });
        
          toggleBtn.innerHTML = collapsed
            ? `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h10M7 16h10M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
               </svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
               d="M6 18L18 6M6 6l12 12" />
       </svg>`;
        });


      // Handle basemap changes
      

div.querySelectorAll('input[name="basemap"]').forEach((input) => {
  input.addEventListener('change', (e) => {
    Object.values(basemapsarctic).forEach((layer) => map.removeLayer(layer));
  Object.values(basemaps).forEach((layer) => map.removeLayer(layer));
    Object.values(selectedBasemaps).forEach((layer) => map.removeLayer(layer));
    selectedBasemaps[e.target.value].addTo(map);
  });
});


      // Ensure only one product checkbox is selected at a time
      const productRadios = div.querySelectorAll('input[type="radio"][name="product"]');
productRadios.forEach((radio) => {
  radio.addEventListener('change', () => {
    if (radio.checked) {
      if (radio.value === 'Inventory of Subglacial Water') {
        navigate(`?id=11309301`);
      }
      if (radio.value === 'Elevation Change Rate of Glaciers') {
        navigate(`?id=11311271`);
      }
      if (radio.value === 'Circumpolar Arctic Vegetation') {
        navigate(`?id=11405141`);
      }
        if (radio.value === 'Temperature and Pressure Wells in Kaffiøyra') {
        navigate(`?id=11410231`);
      }
      if (radio.value === 'Shorelines and glacier outlines in Kaffiøyra') {
        navigate(`?id=11411141`);
      }
    }
  });
});

        
      // Collapse ENTIRE panel when selecting ANY radio option
div.querySelectorAll('input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', () => {
    collapsed = true;
    const panel = div.querySelector('.panel-section');
    panel.classList.add('hidden');

    // reset all section contents to collapsed mode (arrows = ▶)
    const contents = div.querySelectorAll('.section-content');
    const icons = div.querySelectorAll('.toggle-icon');

    contents.forEach((content) => content.classList.add('hidden'));
    icons.forEach((icon) => (icon.textContent = '▶'));

    // update toggle button icon
    toggleBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 8h10M7 12h10M7 16h10M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    `;
  });
});

   
      // Ensure only one view checkbox is selected at a time
        const viewRadios = div.querySelectorAll('input[type="radio"][name="view"]');
viewRadios.forEach((radio) => {
  radio.addEventListener('change', () => {
    if (radio.checked) {
      if (radio.value === 'Arctic') {
        localStorage.setItem('crs', 'ok');
      }
      if (radio.value === 'Geographical') {
        localStorage.setItem('crs', '002');
      }
    }
  });
});

        // Store reference to coordinate box
      const coordBox = div.querySelector('#coord-box');
      setCoordEl(coordBox);

      return div;
    };

    control.addTo(map);

      

    return () => {map.removeControl(control);
                 setCoordEl(null);
                 }
  }, [map, layer1]);

  return null;
};

const generateProducts = (items, id) => {
  return items
    .map((text, i) => {
      const isChecked =
        (id === '11309301' && text === 'Inventory of Subglacial Water') ||
        (id === '11311271' && text === 'Elevation Change Rate of Glaciers') ||
        (id === '11405141' && text === 'Circumpolar Arctic Vegetation') ||
          (id === '11410231' && text === 'Temperature and Pressure Wells in Kaffiøyra') ||
          (id === '11411141' && text === 'Shorelines and glacier outlines in Kaffiøyra');

      const sliderId = `opacity-slider-${i}`;
      const sliderClass = `w-full cursor-pointer ${isChecked ? '' : 'hidden'}`;

      // always start at 1 (default)
      return `
        <div class="flex flex-col gap-1 mb-2">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="product"
              value="${text}"
              class="radio"
              data-slider="#${sliderId}"
              ${isChecked ? 'checked' : ''}
            >
            <span>${text}</span>
          </label>
          <input
            type="range"
            id="${sliderId}"
            min="0"
            max="1"
            step="0.05"
            value="1"
             title="Transparency"
            class="${sliderClass}"
            data-product="${text}"
          >
        </div>
      `;
    })
    .join('');
};

window.addEventListener('load', () => {
  localStorage.setItem('opacity', 1);
  console.log('🔁 Page loaded — opacity reset to 1');
});

// === When switching dataset ===
document.addEventListener('change', (e) => {
  if (e.target.name === 'product') {
    // Hide and reset all sliders
    document.querySelectorAll('input[type="range"][id^="opacity-slider-"]').forEach((s) => {
      s.classList.add('hidden');
      s.value = 1; // reset every slider to default 1
      localStorage.setItem(`opacity`, 1); // optional
    });

    // Show only the selected dataset’s slider
    const target = document.querySelector(e.target.dataset.slider);
    if (target) {
      target.classList.remove('hidden');
      target.value = 1; // ensure it’s set to 1 on change
      localStorage.setItem(`opacity`, 1);
      
    }
  }
});

// === When moving the slider ===
document.addEventListener('input', (e) => {
  if (e.target.type === 'range' && e.target.dataset.product) {
    const product = e.target.dataset.product;
    const val = e.target.value;
    localStorage.setItem(`opacity`, val);
  }
});



const generateView = (items, selectedLayer1) => {
  return items
    .map((text) => {
      const isChecked =
        (localStorage.getItem('crs') === 'ok' && text === 'Arctic') ||
        (localStorage.getItem('crs') === '002' && text === 'Geographical');

      return `
        <div class="flex items-center justify-between">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" name="view" value="${text}" ${isChecked ? 'checked' : ''} class="radio">
            <span>${text}</span>
          </label>
        </div>
      `;
    })
    .join('');
};


export default DropdownControl;